//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            po_number: null
        };
    },
    created: function created() {
        this.qty = this.value;
        this.$emit('change', this.qty);
    },


    methods: {
        checkLength: function checkLength() {
            if (this.po_number.length > 35) {
                this.po_number = this.po_number.substr(0, 35);
            }
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/extra-fields/components/ExtraFields.vue
// module id = hFcD
// module chunks = 4